import _ from 'lodash';
import * as Connections from "./Connections";

const Helpers = {

  processObjectKeys(obj, convert) {
    let output;

    if ( _.isDate(obj) || _.isRegExp(obj) || !_.isObject(obj) ) {
      return obj;
    } else if ( _.isArray(obj) ) {
      output = _.map(obj, item => {
        return this.processObjectKeys(item, convert);
      });
    } else {
      output = {};
      _.forOwn(obj, (value, key) => {
        output[convert(key)] = this.processObjectKeys(obj[key], convert);
      });
    }

    return output;
  },
  getImageName(imageName) {
    return Connections.getProduceImageLink() + imageName.replace(" ", "").toLowerCase() + ".jpg";
  },
  getFarmerImage(imageName) {
    return Connections.getProfileImageLink() + imageName
  }

};

export default Helpers;



// WEBPACK FOOTER //
// ./src/utils/Helpers.js